import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/modules/auth";

export const Route = createFileRoute("/_private/_layout/sign-in")({
  component: Auth,
});
